module.exports = __webpack_public_path__ + "static/media/appstore.75c18b83.png";